import React, { FC, useCallback, useMemo, useState } from 'react';
import { compareStrings, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Button, message } from 'antd';
import { connect } from 'react-redux';
import { remindBiddersToMakeProposal } from '../../thunks/bidders_thunks';
import { withRouter } from 'react-router';
import { BIDDER_STATUSES } from '../../constants/BidderStatuses';

const BidderSendReminderButton: FC<any> = ({
	bidder,
	requestForProposal,
	remindBidders,
}): React.ReactElement => {
	const bidderStatus = useMemo(() => nullSafeGet('bidderStatus', bidder), [bidder]);
	const [loading, setLoading] = useState(false);

	const onSendReminder = useCallback(() => {
		setLoading(true);
		remindBidders(bidder.requestForProposalId, bidder.supplierFacilityId)
			.catch(message.error)
			.finally(() => setLoading(false));
	}, [bidder.requestForProposalId, bidder.supplierFacilityId, remindBidders]);

	return (compareStrings(bidderStatus, BIDDER_STATUSES.NO_RESPONSE) ||
		compareStrings(bidderStatus, BIDDER_STATUSES.INTERESTED) ||
		compareStrings(bidderStatus, BIDDER_STATUSES.IN_DRAFT)) &&
		nullSafeGetOrElse('status', requestForProposal, 'draft') === 'active' ? (
		<Button loading={loading} onClick={onSendReminder}>
			Send Reminder
		</Button>
	) : null;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	remindBidders: (id, supplierFacilityId) =>
		dispatch(remindBiddersToMakeProposal(ownProps.userType)(id, supplierFacilityId)),
});

const ComponentWithoutUserType = withRouter(
	connect(null, mapDispatchToProps)(BidderSendReminderButton)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
